// custom typefaces
import "typeface-montserrat"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks - using tomorrow theme for better look
import "prismjs/themes/prism-tomorrow.css"

// Add copy buttons to code blocks
export const onRouteUpdate = () => {
  // Add copy buttons to all code blocks
  const codeBlocks = document.querySelectorAll('.gatsby-highlight pre[class*="language-"]')

  codeBlocks.forEach(block => {
    // Skip if button already exists
    if (block.parentElement.querySelector('.code-copy-button')) {
      return
    }

    const button = document.createElement('button')
    button.className = 'code-copy-button'
    button.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
      </svg>
      <span class="copy-button-text">Copy</span>
    `

    button.addEventListener('click', async () => {
      const code = block.textContent
      try {
        await navigator.clipboard.writeText(code)
        button.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
          <span class="copy-button-text">Copied!</span>
        `
        setTimeout(() => {
          button.innerHTML = `
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
            </svg>
            <span class="copy-button-text">Copy</span>
          `
        }, 2000)
      } catch (err) {
        console.error('Failed to copy:', err)
      }
    })

    block.parentElement.appendChild(button)
  })
}
